import useWhitelabel from "hooks/useWhitelabel";
import PropertyCTAs from "../PropertyCTAs";
import PropertyUSPs from "../USPSection";
import styles from "./RightSection.module.scss";
import wrapperHOC from "@Utils/wrapperHOC";
import SalesOfferSection from "../SalesOfferSection";
import GroupBookingSection from "../GroupBookingSection";
import config from "@Config/index";

const RightSection = ({ inventoryMeta }: any) => {
  const { isWhitelabel } = useWhitelabel();
  return (
    <div className={styles.container}>
      <PropertyCTAs isDesktop />
      <SalesOfferSection inventoryMeta={inventoryMeta} />
      {!isWhitelabel && (
        <div className={styles.subSection}>
          <PropertyUSPs isDesktop showMoveInBuddy />
        </div>
      )}
      {config.IS_CHINA_APP && <GroupBookingSection />}
    </div>
  );
};

export default wrapperHOC(RightSection, {
  componentName: "RightSection-PropertyPage",
  showForChina: true,
});
